var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('room-list',{staticClass:"p-4",attrs:{"buildingId":_vm.$route.params.buildingId,"buildingGroupId":_vm.$route.params.groupId}})}
var staticRenderFns = []

export { render, staticRenderFns }